import React from "react";

import CollapsibleText from "@components/shared/CollapsibleText/CollapsibleText";
import ContactPerson from "@components/shared/ContactPerson/ContactPerson";
import { UnitInformationPropsType } from "@models/components/units.model";
import { applyLocalization } from "@services/common.service";

const UnitInformation: React.FC<UnitInformationPropsType> = ({
  contactList,
  locationId,
  resourceInfo,
  unitId,
}) => {
  return (
    <div data-testid="unitInformation">
      <CollapsibleText
        content={applyLocalization(resourceInfo?.info?.description)}
        className="fg-tab-welcome-block fg-border-none pt-0 "
      />
      <ContactPerson
        contactList={contactList}
        isVisible={contactList?.length > 0}
        locationId={locationId}
        unitId={unitId}
      />
    </div>
  );
};

export default UnitInformation;
